import { render, staticRenderFns } from "./NpaPromotionHistoryAdd.vue?vue&type=template&id=30a8f406&scoped=true"
import script from "./NpaPromotionHistoryAdd.vue?vue&type=script&lang=js"
export * from "./NpaPromotionHistoryAdd.vue?vue&type=script&lang=js"
import style0 from "./NpaPromotionHistoryAdd.vue?vue&type=style&index=0&id=30a8f406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a8f406",
  null
  
)

export default component.exports